import { SET_CUSTOMISE_BUTTON } from "./customiseButton.type";

export const setCustomiseButtonClick = (customise_button_click) => {
  return {
    type: SET_CUSTOMISE_BUTTON,
    payload: customise_button_click
  };
};
